var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72485 4.66797H7.39087V12.4479H9.72485V4.66797Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2258 7.00195H10.8918V12.4479H13.2258V7.00195Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22388 9.33594H3.88989V12.4479H6.22388V9.33594Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1159 8.55794C17.1159 3.83149 13.2844 0 8.55794 0C3.83149 0 0 3.83149 0 8.55794C0 13.2844 3.83149 17.1159 8.55794 17.1159C10.6411 17.1159 12.549 16.3703 14.033 15.1331L18.8998 20L20 18.8998L15.1332 14.033C16.3703 12.549 17.1159 10.6411 17.1159 8.55794ZM8.55794 15.5599C4.69705 15.5599 1.55599 12.4188 1.55599 8.55794C1.55599 4.69705 4.69705 1.55599 8.55794 1.55599C12.4188 1.55599 15.56 4.69705 15.56 8.55794C15.56 12.4188 12.4188 15.5599 8.55794 15.5599Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendation);
export default __webpack_public_path__ + "static/media/recommendation.242b4d6b142fe94596375c3f287deda1.svg";
export { ForwardRef as ReactComponent };